import { render } from "./index.vue?vue&type=template&id=3ad86352&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3ad86352&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/open-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad86352"]])

export default __exports__